import React from 'react';

import { FormField, Heading, Label } from '@zillow/constellation-10';

import type { Section } from '../../../../../models';
import YesAndNo from '../../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  utilityIndividuallyMeteredField: string;
  setSectionValues: (keyValuePairs: object) => void;
  utilityName: string;
};

export default function UtilitiesIndividuallyMetered({
  section,
  setSectionValues,
  utilityName,
  utilityIndividuallyMeteredField,
}: Props): JSX.Element {
  function onNoSeparatelyMetered(): void {
    setSectionValues({
      [utilityIndividuallyMeteredField]: false,
    });
  }

  function onYesSeparatelyMetered(): void {
    setSectionValues({
      [utilityIndividuallyMeteredField]: true,
    });
  }

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-xs" css={{ marginBottom: 'layout.tight' }}>
        {utilityName}
      </Heading>
      <FormField
        required
        label={<Label>{`Is ${utilityName.toLowerCase()} separately metered?`}</Label>}
        control={
          <YesAndNo
            yesHandler={onYesSeparatelyMetered}
            noHandler={onNoSeparatelyMetered}
            yesActive={section.getFieldValue(utilityIndividuallyMeteredField)}
          />
        }
      />
    </>
  );
}
